const CookieJwtName = 'backoffice.sid';

export const getToken = (): string | null => {
    const cookieName = CookieJwtName;

    if (typeof window === 'undefined') {
        return null;
    }

    const match = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`));
    return match && (match[1] ?? null);
};

